import { render, staticRenderFns } from "./AddAgent.vue?vue&type=template&id=45b7c618&scoped=true&"
import script from "./AddAgent.vue?vue&type=script&lang=js&"
export * from "./AddAgent.vue?vue&type=script&lang=js&"
import style0 from "./AddAgent.vue?vue&type=style&index=0&id=45b7c618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7c618",
  null
  
)

export default component.exports